import { SavePage } from "utils";

export const handleSelectSort = (e, navigate, info) => {
  const params = {
    ...info,
  };
  params.page = 1;
  params.skip = 0;
  if (e.target.value === "All") {
    delete params[e.target.name];
    SavePage(navigate, info, { ...params });
  } else {
    if (!e.target.value) {
      delete params[e.target.name];
      SavePage(navigate, info, { ...params });
    } else {
      params[e.target.name] = e.target.value;
      SavePage(navigate, info, { ...params });
    }
  }
};

export const handleSelectMultiple = (e, navigate, info, selected) => {
  const params = {
    ...info,
  };
  params.page = 1;
  params.skip = 0;

  const currentArray = selected?.length
    ? selected
    : info?.[e.target.name]
      ? info?.[e.target.name]
      : [];
  if (e.target.value === "All") {
    params[e.target.name] = [];
    SavePage(navigate, info, { ...params });
  } else {
    const currentValue = currentArray?.find((item) => item === e.target.value);

    if (currentValue) {
      params[e.target.name] = currentArray?.filter(
        (item) => item !== e.target.value,
      );
    } else {
      params[e.target.name] = [...currentArray, e.target.value];
    }

    SavePage(navigate, info, { ...params });
  }
};
